import React, { useState, useEffect, useMemo } from "react";
import LineChartComponent from "./common/LineChart.js";
import TabPanel from "./common/TabPanel";
import ParameterTable from "./common/ParameterTable";
import { parameterGroups } from "./OtherParameters"; // Import from OtherParameters
import Papa from "papaparse";
import Select from 'react-select/async';
import debounce from 'lodash/debounce';
import axios from "axios";
import { API_ENDPOINTS } from "../../../config/apiConfig";

// Define tab configuration
const touTabs = [
  { id: "depot", label: "Depot Charging" },
  { id: "public", label: "Public Charging" },
  { id: "diesel", label: "Diesel" }
];

const initialEnergyChargeData = [
  { x: 0, y: 0.17133 },
  { x: 1, y: 0.17133 },
  { x: 2, y: 0.17133 },
  { x: 3, y: 0.17133 },
  { x: 4, y: 0.17133 },
  { x: 5, y: 0.17133 },
  { x: 6, y: 0.17133 },
  { x: 7, y: 0.17133 },
  { x: 8, y: 0.17133 },
  { x: 9, y: 0.17133 },
  { x: 10, y: 0.17133 },
  { x: 11, y: 0.17133 },
  { x: 12, y: 0.17133 },
  { x: 13, y: 0.17133 },
  { x: 14, y: 0.17133 },
  { x: 15, y: 0.17133 },
  { x: 16, y: 0.46034 },
  { x: 17, y: 0.46034 },
  { x: 18, y: 0.46034 },
  { x: 19, y: 0.46034 },
  { x: 20, y: 0.46034 },
  { x: 21, y: 0.17133 },
  { x: 22, y: 0.17133 },
  { x: 23, y: 0.17133 },
];

// Add TOU preprocessing function
export const expandEnergyChargeData = (data) => {
  // Maps 1-hour increment to 15-minute increment
  return data.reduce((result, { x, y }) => {
    for (let i = 0; i < 4; i++) {
      result[x * 4 + i] = y; // Add key-value pair to the result
    }
    return result;
  }, {});
};

const EnergyRate = ({
  energyChargeData,
  setEnergyChargeData,
  otherParameters,
  setOtherParameters,
  nextStep,
  prevStep
}) => {
  const authToken = localStorage.getItem("authToken");
  const [activeTab, setActiveTab] = useState("depot");
  const [selectedTOU, setSelectedTOU] = useState(null);
  const [touData, setTouData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadOptions = useMemo(
    () =>
      debounce((inputValue, callback) => {
        const searchTerms = inputValue.toLowerCase().split(/[\s,]+/);

        const filteredOptions = (touData || [])
          .filter(row => {
            const searchableFields = [
              row.rin,
              row.distributor,
              row.energy_company,
              row.rate_name,
              row.state,
              row.description
            ].map(field => (field || '').toString().toLowerCase());

            return searchTerms.every(term =>
              searchableFields.some(field => field.includes(term))
            );
          })
          .slice(0, 100)
          .map(row => ({
            value: row.rin,
            distributor: row.distributor,
            energyCompany: row.energy_company,
            label: `${row.rin} - ${row.distributor} - ${row.energy_company}`,
            data: row
          }));

        callback(filteredOptions);
      }, 300),
    [touData]
  );

  // const fetchTOUData = async () => {
  //   try {
  //     setIsLoading(true);
  //     setError(null);
  //     const response = await axios.get(API_ENDPOINTS.getMidasRins, {
  //       headers: {
  //         Authorization: `Token ${authToken}`,
  //       },
  //     });
      
  //     if (!Array.isArray(response.data)) {
  //       throw new Error('Invalid TOU data format received');
  //     }
      
  //     setTouData(response.data);
  //   } catch (error) {
  //     console.error("Error fetching TOU data:", error);
  //     setError(error.message || 'Failed to load TOU data');
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchTOUData();
  // }, []);

  useEffect(() => {
    if (energyChargeData.length === 0) {
      setEnergyChargeData(initialEnergyChargeData);
    }
  }, [energyChargeData, setEnergyChargeData]);

  // if (isLoading) {
  //   return <div className="p-6 text-center text-gray-500">Loading TOU data...</div>;
  //   return <div className="loading-state">Loading TOU data...</div>;
  // }

  // if (error) {
  //   return (
  //     <div className="p-6 text-center text-red-500">
  //       <p>Error: {error}</p>
  //       <button onClick={fetchTOUData} className="ml-4 text-blue-600 hover:underline">Retry</button>
  //     </div>
  //   );
  // }

  // if (!touData || touData.length === 0) {
  //   return <div className="p-6 text-center text-gray-500">No TOU data available.</div>;
  //   return <div>No TOU data available</div>;
  // }

  console.log("TOU Data", touData);

  console.log("Selected TOU", selectedTOU);

  // Handle TOU schedule selection
  const handleTOUChange = (selectedOption) => {
    setSelectedTOU(selectedOption);
    if (selectedOption?.data) {
      const newEnergyChargeData = transformTOUDataToChartFormat(selectedOption.data);
      setEnergyChargeData(newEnergyChargeData);
    }
  };

  const handleGetTOUSchedule = (RIN) => {
    console.log("Getting TOU Schedule");
  }

  // Helper function to transform TOU data
  const transformTOUDataToChartFormat = (touData) => {
    // Adjust this based on your CSV data structure
    return Array.from({ length: 24 }, (_, hour) => ({
      x: hour,
      y: parseFloat(touData[`hour_${hour}`] || touData[`rate_${hour}`] || 0)
    }));
  };
  // Handle parameter changes
  const handleInputChange = (id, value) => {
    setOtherParameters(prev => ({
      ...prev,
      [id]: value,
    }));
  };

  // Format currency values with decimal places
  const formatCurrency = (value) => {
    return parseFloat(value).toFixed(4);
  };

  const reactSelectStyles = {
    control: (base) => ({ ...base, minHeight: '42px', cursor: 'text', boxShadow: 'none', '&:hover': { borderColor: '#a0aec0' } }),
    menu: (base) => ({ ...base, zIndex: 30 }),
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <TabPanel
        tabs={touTabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      >
        <div className="tab-panel-section">
          <div className="grid grid-cols-1 gap-8 mb-6">
            <div>
              <h3 className="font-bold text-lg text-gray-800 mb-2">Energy Charges</h3>
              <p className="text-sm text-gray-600">These are the time-of-use (TOU) rates your depot pays. The example shows SCE's EV-9 Schedule. You can also download the template, make adjustments, and re-upload.</p>
            </div>
            {/* <div>
              <h3 className="font-bold text-lg text-gray-800 mb-2">Select a TOU Schedule</h3>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            {/* <div style={{ width: '45%', marginRight: '20px' }}> */}
            {/*<div>
              <h3>Energy Charges</h3>
              <p style={{ textAlign: 'justify' }}>These are the time-of-use (TOU) rates your depot pays to the utility. The example shows SCE's EV-9 Schedule for 2kV-50kV customers. You can download the CSV template, make adjustments, and upload it again.</p>
            </div>*/}
            {/* <div style={{ width: '45%' }}>
              <h3>Select a TOU schedule</h3>
              <Select
                cacheOptions
                defaultOptions
                value={selectedTOU}
                onChange={handleTOUChange}
                loadOptions={loadOptions}
                isSearchable={true}
                placeholder="Search for a TOU schedule..."
                styles={reactSelectStyles}
              />
              <button
                className="btn btn-primary p-4"
                onClick={() => handleGetTOUSchedule(selectedTOU?.value)}
                disabled={!selectedTOU}
              >
                Get TOU Schedule
              </button>
            </div> */}
          </div>

          <div className="tou-chart-container">
            <LineChartComponent
              xLabel="Time of Day (Hour)"
              yLabel="Energy Charge ($/kWh)"
              initialData={energyChargeData.length > 0 ? energyChargeData : initialEnergyChargeData}
              onDataUpdate={setEnergyChargeData}
            />
          </div>
          <div className="parameters-section" style={{ marginTop: '20px', marginBottom: '20px' }}>
            <h3 className="font-bold text-lg text-gray-800 mb-2">Demand Charges</h3>
            <p className="text-sm text-gray-600 mb-4">This is part of your bill based on peak load. Enter the monthly power demand charges from your utility. (Note: SCE's EV-9 Schedule currently has no demand charges).</p>
            <ParameterTable
              parameters={parameterGroups.depotCharging.inputs}
              values={otherParameters}
              onValueChange={handleInputChange}
              formatValue={formatCurrency}
            />
          </div>
        </div>

        {/* Tab 2: Public Charging */}
        <div className="tab-panel-section">
          <h3 className="font-bold text-lg text-gray-800 mb-2">Public Charging Settings</h3>
          <p className="text-sm text-gray-600 mb-4">Most third-party public charging stations add fees on top of utility rates. We are actively working to bring more pricing options to this platform. Stay tuned!</p>

          <div className="parameters-section">
            <ParameterTable
              parameters={parameterGroups.publicCharging.inputs}
              values={otherParameters}
              onValueChange={handleInputChange}
              formatValue={formatCurrency}
            />
          </div>
        </div>

        {/* Tab 3: Diesel */}
        <div className="tab-panel-section">
          <h3 className="font-bold text-lg text-gray-800 mb-2">Diesel Fuel Settings</h3>
          <p className="text-sm text-gray-600 mb-4">Configure diesel fuel costs for comparison purposes.</p>

          <div className="parameters-section">
            <ParameterTable
              parameters={parameterGroups.diesel.inputs}
              values={otherParameters}
              onValueChange={handleInputChange}
              formatValue={formatCurrency}
            />
          </div>
        </div>
      </TabPanel>
    </div>
  );
};

export default EnergyRate; 